module.exports = __webpack_public_path__ + "static/media/loading_img.25ef2804.gif";


//////////////////
// WEBPACK FOOTER
// ./src/image/loading_img.gif
// module id = 56
// module chunks = 0